import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-no-internet-connection-modal',
  templateUrl: './no-internet-connection-modal.component.html',
  styleUrls: ['./no-internet-connection-modal.component.css']
})
export class NoInternetConnectionModalComponent implements OnInit {

  public connectionRestored = false;
  constructor(
    private dialogRef: MatDialogRef<NoInternetConnectionModalComponent>,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
  }

  closeClick() {
    this.hideSpinner();
    this.dialogRef.close();
  }

  logOutClick() {
    window.location.reload();
  }

  hideSpinner() {
    this.sharedService.updateShowSpinner(false);
  }

}
